export default __webpack_public_path__ + "static/media/Flag of Moldova.4366d8b4.gif";